<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="head-container">
<!--      <el-select
        v-model="queryParams.status"
        placeholder="状态"
        clearable
        style="width: 120px"
      >
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select> -->
      <el-button
        @click="handleAdd"
        type="primary"
        icon="el-icon-plus"
      >新增</el-button>
    </div>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="list"
      border
      style="width: 100%;margin-top:10px;"
    >
      <el-table-column label="校区ID" align="center" prop="id" />
      <el-table-column label="校区名称" align="center" prop="areaName" />
      <el-table-column label="校区编码" align="center" prop="areaCode" />
      <el-table-column label="主校区" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isMain == 1 ? 'success' : 'info'">
            {{ scope.row.isMain == 1 ? "是" : "否" }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="所属学校ID" align="center" prop="schoolId" /> -->
      <el-table-column label="详细地址" align="center" prop="address" />
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.status"
            :active-value="1"
            :inactive-value="0"
			:disabled="scope.row.isMain==1"
            @change="handleStatusChange(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createTime" />
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button
            icon="el-icon-edit"
            size="mini"
            type="primary"
            @click="handleUpdate(scope.row)"
          >编辑</el-button>
          <el-button
            icon="el-icon-delete"
            size="mini"
            type="danger"
            v-if="scope.row.isMain != 1"
            @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
<!--    <pagination
      :total="total"
      :page="queryParams.pageNum"
      :limit="queryParams.pageSize"
      @pagination="getList"
    /> -->

    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="open" width="600px"  :append-to-body="true" center
		  	>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="校区名称" prop="areaName">
          <el-input 
            v-model="form.areaName" 
            placeholder="请输入校区名称" 
            maxlength="8"
          >
            
            <span slot="suffix" style="color:#999;font-size:12px;white-space:nowrap;margin-left:6px;">
              <span style="color: #409EFF;">{{ (form.areaName || '').length }}</span>/8
            </span>
            
            <template slot="prepend"></template>
            
          </el-input>
        </el-form-item>
        <el-form-item label="校区编码" prop="areaCode">
          <el-input v-model="form.areaCode" placeholder="请输入校区编码" />
        </el-form-item>
        
        <el-form-item label="地址">
          <el-input
            v-model="form.address"
            type="textarea"
            rows="3"
            placeholder="请输入地址"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1" :disabled="form.isMain==1">启用</el-radio>
            <el-radio :label="0" :disabled="form.isMain==1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="open = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "SchoolArea",
  data() {
    return {
      schoolList: [],
      list: [],
      loading: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        areaName: undefined,
        schoolId: localStorage.getItem('orgId'),
        status: undefined
      },
      open: false,
      title: "",
      // 新增默认非主校区 isMain固定0
      form: { isMain:0, status:1 },
      rules: {
        schoolId: [{ required: true, message: "请选择学校", trigger: "change" }],
        areaName: [{ required: true, message: "请输入校区名称", trigger: "blur" }],
        areaCode: [{ required: true, message: "请输入校区编码", trigger: "blur" }]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const res = await this.API.get(this.API.school.getSchoolAreaList,this.queryParams)
      this.list = res.data.data;
      this.total = res.data.total;
      this.loading = false;
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        areaName: "",
        schoolId: localStorage.getItem('orgId'),
        status: null
      };
      this.getList();
    },
    handleAdd() {
      // 新增固定非主校区，前端无法修改
      this.form = { isMain: 0, status: 1 };
      this.title = "新增校区";
      this.open = true;
    },
    async handleUpdate(row) {
		
      const res = await this.API.get(this.API.school.getSchoolArea+row.id)
      console.log('rrr',res.data.data)
	  this.form = res.data.data;
      // 编辑时前端依然不能改isMain，表单无控件
      this.title = "修改校区";
	  
      this.open = true;
    },
    submitForm() {
		this.form.schoolId=localStorage.getItem('orgId')
      this.$refs.form.validate(async (valid) => {
        if (valid) {
			
          if (this.form.id) {
            await this.API.put(this.API.school.putSchoolAreaUpdate,this.form)
          } else {
            await this.API.post(this.API.school.postSchoolAreaAdd,this.form)
          }
          this.$message.success("操作成功");
          this.open = false;
          this.getList();
        }
      });
    },
    // 删除前二次校验弹窗提示
    handleDelete(row) {
      if(row.isMain === 1){
        this.$message.warning("主校区禁止删除！");
        return;
      }
      this.$confirm("确定删除该校区？", "提示", {type:"warning"}).then(async ()=>{
        await this.API.deleted(this.API.school.deletedSchoolArea+row.id)
		
        this.$message.success("删除成功");
        this.getList();
      })
    },
    async handleStatusChange(row) {
		await this.API.put(this.API.school.putSchoolAreaChangeStatus,{ id: row.id, status: row.status==1?0:1 })
		this.getList()
	  this.$message.success("状态修改成功");
    }
  }
};
</script>

<style scoped>
.app-container {
  width: calc(80vw);
  padding: 20px;
}
</style>